class Type {
	public static RESELLER_BILLED = new Type("RESELLER_BILLED");
	public static NOT_RECURLY = new Type("NOT_RECURLY");

	private constructor(public readonly value: string) {}

	public matches(value?: string) {
		return this.value === value;
	}
}

export { Type as BillingIneligibleReasonType };
